import PropTypes from 'prop-types';

export default {
  title: PropTypes.string.isRequired,
  meta: PropTypes.array,
  links: PropTypes.array,
};
